export const iframeConfig = {
  enabled: false,
};
